import axios from 'axios';
import { processResponse, processError, privateRequestParams, publicRequestParams, publicRequestParams2, createQueryFromObject, defaultTimeout } from '../utils';
import { hasAuthAccessParams } from '../types/guards';
export default class HeroUsersAPI {
    static getPublicToken(accessParams) {
        return axios
            .post(accessParams.API_ENDPOINT + 'o/token/', createQueryFromObject({ grant_type: 'client_credentials' }), {
            withCredentials: true,
            auth: {
                username: accessParams.API_PUBLIC_USER,
                password: accessParams.API_PUBLIC_PASS
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            timeout: defaultTimeout
        })
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static getPrivateToken(accessParams, username, pass) {
        return axios
            .post(accessParams.API_ENDPOINT + 'frontend/login/', {
            username,
            password: pass,
            client: 'frontend_registered'
        })
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static refreshPrivateToken(accessParams) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .post(accessParams.API_ENDPOINT + 'frontend/refresh-token/', {
            refresh_token: accessParams.refresh_token,
            client: 'frontend_registered'
        })
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static register(accessParams, { email, password, first_name, last_name, caregiver_flag, owner_name, date_of_birth, gender, caregiver_invite_id }) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        const payload = Object.assign(Object.assign(Object.assign({ email,
            password,
            first_name,
            last_name,
            date_of_birth,
            gender }, (caregiver_flag && { caregiver_flag: true })), (owner_name && { owner_name })), (caregiver_invite_id && { caregiver_invite_id }));
        return axios
            .post(accessParams.API_ENDPOINT + 'frontend/register/', payload, publicRequestParams(accessParams))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static activateUser(constAccessParams, params) {
        return axios
            .post(constAccessParams.API_ENDPOINT + 'frontend/activate/', params, publicRequestParams2())
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static resendActivationCode(accessParams, caregiver_flag) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .post(accessParams.API_ENDPOINT + 'frontend/resend-activation-code/', { caregiver_flag }, privateRequestParams(accessParams))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static resetPasswordSendMail(accessParams, email) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .post(accessParams.API_ENDPOINT + 'frontend/forgot-pass/', { email }, publicRequestParams(accessParams))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static setPassword(accessParams, email, forgot_pass_token, password) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .put(accessParams.API_ENDPOINT + 'frontend/forgot-pass/', { email, forgot_pass_token, password }, publicRequestParams(accessParams))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static userStatus(accessParams, isForOwner) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .get(accessParams.API_ENDPOINT + 'frontend/user-status/', privateRequestParams(accessParams, {
            timeout: 15000,
            params: isForOwner ? { is_for_owner: true } : {}
        }))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static fetchUserInfo(accessParams, email) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .post(accessParams.API_ENDPOINT + 'frontend/user-info/', { email }, publicRequestParams(accessParams))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static pair(accessParams, pin) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .post(accessParams.API_ENDPOINT + 'frontend/pair-by-pin/', { pin }, privateRequestParams(accessParams))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static delete(accessParams) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .delete(accessParams.API_ENDPOINT + 'frontend/delete-account/', privateRequestParams(accessParams))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static getUserPreferences(accessParams) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .get(accessParams.API_ENDPOINT + 'frontend/owner-push-notification-preferences/', privateRequestParams(accessParams))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static setUserPreferences(accessParams, notify_hero_offline, notify_dispensed_extra_pills) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .post(accessParams.API_ENDPOINT + 'frontend/owner-push-notification-preferences/', {
            notify_hero_offline,
            notify_dispensed_extra_pills
        }, privateRequestParams(accessParams))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static unsubscribe(accessParams, email, account_id, mailing_list) {
        return axios
            .post(accessParams.API_ENDPOINT + 'frontend/unsubscribe-from-mailing-list/', {
            email,
            account_id,
            mailing_list
        })
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
}
//# sourceMappingURL=index.js.map